import { baseUrl, handleResponse, handleError, PutOptions, GetHeaders } from "../../../../apis/common/ApiUtils";


const apiUrl = baseUrl + "travel/vouchergroup";

export function getVoucherGroups() {
    const result = fetch(`${apiUrl}`, GetHeaders()).then(handleResponse).catch(handleError);
    return result;
}

export function getVoucherGroupTypes() {
    const result = fetch(`${apiUrl}/types`, GetHeaders()).then(handleResponse).catch(handleError);
    return result;
}

export function getIssueDateTypes() {
    return fetch(`${apiUrl}/issuedatetypes`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getVoucherGroup(voucherGroupId) {
    const result = fetch(`${apiUrl}/${voucherGroupId}`, GetHeaders()).then(handleResponse).catch(handleError);
    return result;
}

export function getVouchersForGroup(groupId) {
    const result = fetch(`${apiUrl}/${groupId}/vouchers`, GetHeaders())
        .then(handleResponse)
        .catch(handleError);
    return result;
}

export function updateVoucherGroup(groupId, group) {
    return fetch(`${apiUrl}/${groupId}/Update`, PutOptions(group)).then(handleResponse).catch(handleError);
}

export function createVoucherGroup(voucherGroup) {
    return fetch(`${apiUrl}/Create`, PutOptions(voucherGroup)).then(handleResponse).catch(handleError);
}

export function issueVoucher(groupId, voucher) {
    return fetch(`${apiUrl}/${groupId}/vouchers/issuevoucher`, PutOptions(voucher))
      .then(handleResponse)
      .catch(handleError);
  }
  
  export function updateVoucher(groupId, voucherId, voucher) {
    return fetch(`${apiUrl}/${groupId}/vouchers/${voucherId}/update`, PutOptions(voucher))
      .then(handleResponse)
      .catch(handleError);
  }

  export function getEligibleEmployees(groupId) {
    return fetch(`${apiUrl}/${groupId}/eligible-employees`, GetHeaders())
        .then(handleResponse)
        .catch(handleError);
}

export function issueVoucherToEmployee(groupId, voucherData) {
    return fetch(`${apiUrl}/${groupId}/vouchers/issuevoucher`, PutOptions(voucherData))
        .then(handleResponse)
        .catch(handleError);
}

export function getAPAccounts() {
    return fetch(`${apiUrl}/apaccounts`, GetHeaders())
        .then(handleResponse)
        .catch(handleError);
}